import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import { Cause } from "../../../api";
import { useAuth } from "../../../hooks";

const causeController = new Cause();

export function SelectCause({ value, onChange, placeholder = "Seleccionar causa", fluid = true }) {
  const { accessToken } = useAuth();
  const [options, setOptions]   = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await causeController.getCauses(accessToken);
        setOptions(data.map((c) => ({ key: c._id, value: c._id, text: c.name })));
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Dropdown
      selection
      search
      fluid={fluid}
      clearable
      placeholder={placeholder}
      options={options}
      value={value || ""}
      onChange={(_, d) => onChange(d.value)}
      loading={loading}
    />
  );
}
